<template>
    <div class="input-group">
        <input class="form-control border input-search sizeH" :class="hasShadow" type="text" :placeholder="localPlaceholder"
            v-model="value">
        <button class="btn border-start-0 border-bottom-0 border bSearch" type="button" @click="updateSearch"
            style="position: absolute;">
            <i class="fa fa-search icon-search"></i>
        </button>

    </div>
</template>

<script>

import { computed } from 'vue'

export default {
    props: {
        modelValue: {
            type: [String, Array],
            default: "",
        },
        hasShadow: {
            type: String,
            default: 'shadow-v2'
        },
        placeholder: String,
    },
    emits: [
        'update:modelValue',
        'updateSearch'
    ],
    setup(props, { emit }) {

        const value = computed({
            get() {
                return props.modelValue
            },
            set(value) {
                emit('update:modelValue', value)
            }
        });

        return {
            value
        }
    },
    data() {
        return {

            localPlaceholder: 'Pesquise..',

        }
    },
    methods: {
        updateSearch() {
            let $this = this;

            $this.$emit('updateSearch');
        }
    },
    mounted() {
        this.localPlaceholder = this.placeholder || this.localPlaceholder;
    }
}
</script>

<style lang="scss" scoped>
.sizeH:focus+.bSearch {
    z-index: 10000001;
}

.sizeH {
    height: 41px;
    border-radius: 5px !important;
}

.bSearch {
    cursor: pointer;
    padding-bottom: 5px;
    top: 2px; 
    right: 10px;
    border: none !important;
}
</style>